'use client';

import { useTranslations } from "next-intl";
import { useCart } from "@/contexts/cart-context";
import { Button } from "@/components/ui/button";
import LoaderCustom from "../custom/loader-custom";
import { FaArrowRight } from "react-icons/fa";

type CheckoutButtonProps = {
  isLoading: boolean;
  onCheckout: () => void;
};

const CheckoutButton = ({ onCheckout, isLoading }: CheckoutButtonProps) => {
  const t = useTranslations("ui");

  return (
    <Button
      disabled={isLoading}
      onClick={() => onCheckout()}
      className="text-sm md:text-base font-medium bg-black rounded-full w-full py-4 h-[54px] md:h-[60px] group"
    >
      {isLoading ? (
        <div className="flex items-center justify-center gap-2">
          <span>{t("processing")}</span>
          <LoaderCustom />
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2">
          {t("go_to_checkout")}
          <FaArrowRight className="text-xl group-hover:translate-x-1 transition-all" />
        </div>
      )}
    </Button>
  );
};

export default CheckoutButton;
